import {remCalc} from '_themeUtils'

export default {
    '@font-face': {
        fontFamily: "'swiper-icons'",
        src: "url('data:application/font-woff;charset=utf-8;base64, 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')",
        fontWeight: 400,
        fontStyle: 'normal',
    },
    '.swiper': {
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        overflow: 'hidden',
        listStyle: 'none',
        padding: '0',
        zIndex: 1,
        maxWidth: '100%',
        display: 'block',
    },
    '.swiper-vertical > .swiper-wrapper': {flexDirection: 'column'},
    '.swiper-wrapper': {
        position: 'relative',
        width: '100%',
        height: '100%',
        zIndex: 1,
        display: 'flex',
        transitionProperty: 'transform',
        boxSizing: 'content-box',
    },
    '.swiper-android .swiper-slide,.swiper-ios .swiper-slide,.swiper-wrapper': {
        transform: 'translate3d(0px, 0, 0)',
    },
    '.swiper-horizontal': {touchAction: 'pan-y'},
    '.swiper-vertical': {touchAction: 'pan-x'},
    '.swiper-slide': {
        flexShrink: 0,
        width: '100%',
        height: '100%',
        position: 'relative',
        transitionProperty: 'transform',
        display: 'block',
    },
    '.swiper-slide-invisible-blank': {visibility: 'hidden'},
    '.swiper-autoheight,.swiper-autoheight .swiper-slide': {height: 'auto'},
    '.swiper-autoheight .swiper-wrapper': {
        alignItems: 'flex-start',
        transitionProperty: 'transform, height',
    },
    '.swiper-backface-hidden .swiper-slide': {
        transform: 'translateZ(0)',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
    },
    '.swiper-3d.swiper-css-mode .swiper-wrapper': {perspective: remCalc(1200)},
    '.swiper-3d .swiper-wrapper': {transformStyle: 'preserve-3d'},
    '.swiper-3d': {perspective: remCalc(1200)},
    '.swiper-3d .swiper-slide,.swiper-3d .swiper-cube-shadow': {
        transformStyle: 'preserve-3d',
    },
    '.swiper-css-mode > .swiper-wrapper': {
        overflow: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    },
    '.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar': {display: 'none'},
    '.swiper-css-mode > .swiper-wrapper > .swiper-slide': {
        scrollSnapAlign: 'start start',
    },
    '.swiper-css-mode.swiper-horizontal > .swiper-wrapper': {
        scrollSnapType: 'x mandatory',
    },
    '.swiper-css-mode.swiper-vertical > .swiper-wrapper': {
        scrollSnapType: 'y mandatory',
    },
    '.swiper-css-mode.swiper-free-mode > .swiper-wrapper': {
        scrollSnapType: 'none',
    },
    '.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide': {
        scrollSnapAlign: 'none',
    },
    '.swiper-css-mode.swiper-centered > .swiper-wrapper::before': {
        content: "''",
        flexShrink: 0,
        order: 9999,
    },
    '.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide': {
        scrollSnapAlign: 'center center',
        scrollSnapStop: 'always',
    },
    '.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-of-type': {
        marginInlineStart: 'var(--swiper-centered-offset-before)',
    },
    '.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before': {
        height: '100%',
        minHeight: remCalc(1),
        width: 'var(--swiper-centered-offset-after)',
    },
    '.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-of-type': {
        marginBlockStart: 'var(--swiper-centered-offset-before)',
    },
    '.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before': {
        width: '100%',
        minWidth: remCalc(1),
        height: 'var(--swiper-centered-offset-after)',
    },
    '.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom':
        {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 'docked',
        },
    '.swiper-3d .swiper-slide-shadow': {background: 'rgba(0, 0, 0, 0.15)'},
    '.swiper-3d .swiper-slide-shadow-left': {
        backgroundImage: 'linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
    },
    '.swiper-3d .swiper-slide-shadow-right': {
        backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
    },
    '.swiper-3d .swiper-slide-shadow-top': {
        backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
    },
    '.swiper-3d .swiper-slide-shadow-bottom': {
        backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
    },
    '.swiper-lazy-preloader': {
        width: remCalc(42),
        height: remCalc(42),
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginLeft: remCalc(-21),
        marginTop: remCalc(-21),
        zIndex: 'docked',
        transformOrigin: '50%',
        boxSizing: 'border-box',
        border: '4px solid black',
        borderRadius: '50%',
        borderTopColor: 'transparent',
    },
    '.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader': {
        animation: 'swiper-preloader-spin 1s infinite linear',
    },
    '.swiper-lazy-preloader-white': {'--swiper-preloader-color': '#fff'},
    '.swiper-lazy-preloader-black': {'--swiper-preloader-color': '#000'},
    '@keyframes swiper-preloader-spin': {
        '0%': {transform: 'rotate(0deg)'},
        '100%': {transform: 'rotate(360deg)'},
    },
    '.swiper .swiper-notification': {
        position: 'absolute',
        left: '0',
        top: '0',
        pointerEvents: 'none',
        opacity: 0,
        zIndex: -1000,
    },
    '.swiper-free-mode > .swiper-wrapper': {
        transitionTimingFunction: 'ease-out',
        margin: '0 auto',
    },
    '.swiper-grid > .swiper-wrapper': {flexWrap: 'wrap'},
    '.swiper-grid-column > .swiper-wrapper': {
        flexWrap: 'wrap',
        flexDirection: 'column',
    },
    '.swiper-fade.swiper-free-mode .swiper-slide': {
        transitionTimingFunction: 'ease-out',
    },
    '.swiper-fade .swiper-slide': {
        pointerEvents: 'none',
        transitionProperty: 'opacity',
    },
    '.swiper-fade .swiper-slide .swiper-slide': {pointerEvents: 'none'},
    '.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active': {
        pointerEvents: 'auto',
    },
    '.swiper-cube': {overflow: 'visible'},
    '.swiper-cube .swiper-slide': {
        pointerEvents: 'none',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        zIndex: 1,
        visibility: 'hidden',
        transformOrigin: '0 0',
        width: '100%',
        height: '100%',
    },
    '.swiper-cube .swiper-slide .swiper-slide': {pointerEvents: 'none'},
    '.swiper-cube.swiper-rtl .swiper-slide': {transformOrigin: '100% 0'},
    '.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active': {
        pointerEvents: 'auto',
    },
    '.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-prev,.swiper-cube .swiper-slide-next + .swiper-slide': {
        pointerEvents: 'auto',
        visibility: 'visible',
    },
    '.swiper-cube .swiper-slide-shadow-top,.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right':
        {
            zIndex: 'base',
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
        },
    '.swiper-cube .swiper-cube-shadow': {
        position: 'absolute',
        left: '0',
        bottom: remCalc(0),
        width: '100%',
        height: '100%',
        opacity: 0.6,
        zIndex: 'base',
    },
    '.swiper-cube .swiper-cube-shadow:before': {
        content: "''",
        background: '#000',
        position: 'absolute',
        left: '0',
        top: '0',
        bottom: '0',
        right: '0',
        filter: 'blur(50px)',
    },
    '.swiper-flip': {overflow: 'visible'},
    '.swiper-flip .swiper-slide': {
        pointerEvents: 'none',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        zIndex: 1,
    },
    '.swiper-flip .swiper-slide .swiper-slide': {pointerEvents: 'none'},
    '.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active': {
        pointerEvents: 'auto',
    },
    '.swiper-flip .swiper-slide-shadow-top,.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right':
        {
            zIndex: 'base',
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
        },
    '.swiper-creative .swiper-slide': {
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        overflow: 'hidden',
        transitionProperty: 'transform, opacity, height',
    },
    '.swiper-cards': {overflow: 'visible'},
    '.swiper-cards .swiper-slide': {
        transformOrigin: 'center bottom',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        overflow: 'hidden',
    },
    '.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal': {
        display: {base: 'none', md: 'block'},
    },

    '.swiper-vertical>.swiper-wrapper': {flexDirection: 'column'},

    '.swiper-android .swiper-slide,.swiper-wrapper': {
        transform: 'translate3d(0px,0,0)',
    },

    '.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper': {
        perspective: remCalc(1200),
    },
    '.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper':
        {
            transformStyle: 'preserve-3d',
        },
    '.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top':
        {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 'docked',
        },

    '.swiper-css-mode>.swiper-wrapper': {
        overflow: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    },
    '.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar': {display: 'none'},
    '.swiper-css-mode>.swiper-wrapper>.swiper-slide': {
        scrollSnapAlign: 'start start',
    },
    '.swiper-horizontal.swiper-css-mode>.swiper-wrapper': {
        scrollSnapType: 'x mandatory',
    },
    '.swiper-vertical.swiper-css-mode>.swiper-wrapper': {
        scrollSnapType: 'y mandatory',
    },
    '.swiper-centered>.swiper-wrapper::before': {
        content: "''",
        flexShrink: 0,
        order: 9999,
    },
    '.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-of-type': {
        marginInlineStart: 'var(--swiper-centered-offset-before)',
    },
    '.swiper-centered.swiper-horizontal>.swiper-wrapper::before': {
        height: '100%',
        minHeight: remCalc(1),
        width: 'var(--swiper-centered-offset-after)',
    },
    '.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-of-type': {
        marginBlockStart: 'var(--swiper-centered-offset-before)',
    },
    '.swiper-centered.swiper-vertical>.swiper-wrapper::before': {
        width: '100%',
        minWidth: remCalc(1),
        height: 'var(--swiper-centered-offset-after)',
    },
    '.swiper-centered>.swiper-wrapper>.swiper-slide': {
        scrollSnapAlign: 'center center',
    },

    '.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet':
        {
            margin: '0px 0.625rem',
        },
    '.swiper-slide-duplicate': {
        display: 'none',
    },
    '.swiper-initialized .swiper-slide-duplicate': {
        display: 'block',
    },
    // scrollbar
    '.swiper-scrollbar': {
        borderRadius: 'var(--swiper-scrollbar-border-radius,10px)',
        position: 'relative',
        touchAction: 'none',
        background: 'var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))',
    },
    '.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled': {
        display: 'none !important',
    },
    '.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal': {
        position: 'absolute',
        left: 'var(--swiper-scrollbar-sides-offset,1%)',
        bottom: 'var(--swiper-scrollbar-bottom,4px)',
        top: 'var(--swiper-scrollbar-top,auto)',
        zIndex: 50,
        height: 'var(--swiper-scrollbar-size,4px)',
        width: 'calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))',
    },
    '.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar': {
        position: 'absolute',
        left: 'var(--swiper-scrollbar-left,auto)',
        right: 'var(--swiper-scrollbar-right,4px)',
        top: 'var(--swiper-scrollbar-sides-offset,1%)',
        zIndex: 50,
        width: 'var(--swiper-scrollbar-size,4px)',
        height: 'calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))',
    },
    '.swiper-scrollbar-drag': {
        height: '100%',
        width: '100%',
        position: 'relative',
        background: 'var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5))',
        borderRadius: 'var(--swiper-scrollbar-border-radius,10px)',
        left: '0',
        top: '0',
    },
    '.swiper-scrollbar-cursor-drag': {cursor: 'move'},
    '.swiper-scrollbar-lock': {display: 'none'},
}
